import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { capturePageview } from './analytics'

/**
 * Un `$pageview` par changement de route. Monté une fois dans `App`.
 *
 * Le site est une application monopage : sans cet envoi manuel, PostHog
 * n'enregistrerait qu'une seule page pour toute la visite (d'où
 * `capture_pageview: false` à l'initialisation).
 *
 * Seul le chemin est observé, pas la chaîne de requête : deux tris d'une même
 * page ne sont pas deux pages consultées.
 */
export function usePageviews() {
  const { pathname } = useLocation()

  useEffect(() => {
    capturePageview(pathname)
  }, [pathname])
}
